import firebase from 'firebase/app';
import 'firebase/firebase-firestore';
import 'firebase/firebase-auth';
import 'firebase/firebase-storage';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB3CYrXv7xp5c8jT7rVjoh1rF8yYTLt8Ws",
  authDomain: "maja-mataric.firebaseapp.com",
  projectId: "maja-mataric",
  storageBucket: "maja-mataric.appspot.com",
  messagingSenderId: "592966797447",
  appId: "1:592966797447:web:82ed7eee4b04e34c801022",
  measurementId: "G-TX35XYE4XJ"
};
const app = firebase.initializeApp(firebaseConfig);

const db = app.firestore();

// if (location.hostname === "localhost") {
//   db.settings({
//     host: "localhost:8080",
//     ssl: false
//   });
// }

export { app, db };